import { configureStore } from "@reduxjs/toolkit";
import studentReducer from "./studentSlice";
import scholarshipReducer from "./scholarshipSlice";
import leftStudentsReducer from "./leftStudentsSlice";
import inactiveStudentsReducer from "./inactiveStudentsSlice";
import miscelleneousFeesReducer from "./miscelleneousFeesSlice";
import admissionFormReducer from "./admissionFormSlice";
import duesFeeReducer from "./duesFeeSlice";
import paidFeeReducer from "./paidFeeSlice";
import feeMasterReducer from "./feeMasterSlice";
import incidentReducer from "./incidentSlice";
import expensesReducer from "./expensesSlice";
import syllabusReducer from "./syllabusSlice";
import samplePaperReducer from "./samplePaperSlice";
import appliedLeaveReducer from "./appliedLeaveSlice";
import gatePassReducer from "./gatePassSlice";

export const store = configureStore({
  reducer: {
    students: studentReducer,
    scholarship: scholarshipReducer,
    leftStudents: leftStudentsReducer,
    inactiveStudents: inactiveStudentsReducer,
    miscelleneousFees: miscelleneousFeesReducer,
    admissionForm: admissionFormReducer,
    duesFee: duesFeeReducer,
    paidFee: paidFeeReducer,
    feeMaster: feeMasterReducer,
    incident: incidentReducer,
    expenses: expensesReducer,
    syllabus: syllabusReducer,
    samplePaper: samplePaperReducer,
    appliedLeave: appliedLeaveReducer,
    gatePass: gatePassReducer,
  },
});
